import cisPie from './pie.vue'
import cisMap from './map.vue'
import cisLine from './line.vue'
import cisBar from './bar.vue'
import cisBarLine from './bar-line.vue'

export default {
  cisPie,
  cisMap,
  cisLine,
  cisBar,
  cisBarLine
}
